module.exports = __webpack_public_path__ + "img/16.31fe0ce7.jpeg";